'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _IconButton = require('@material-ui/core/IconButton');
var _IconButton2 = _interopRequireDefault(_IconButton);
var _Menu = require('@material-ui/icons/Menu');
var _Menu2 = _interopRequireDefault(_Menu);
var _Drawer = require('@material-ui/core/Drawer');
var _Drawer2 = _interopRequireDefault(_Drawer);
var _reactRouter = require('react-router');
var _reactRouterDom = require('react-router-dom');
var _logoEventtia = require('../../assets/logo-eventtia');
var _logoEventtia2 = _interopRequireDefault(_logoEventtia);
var _xTwitter = require('../../assets/icons/x-twitter.svg');
var _xTwitter2 = _interopRequireDefault(_xTwitter);
var _pages = require('../../helpers/pages');
var _misc = require('../../helpers/misc');
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _LanguagesMenu = require('../LanguagesMenu');
var _LanguagesMenu2 = _interopRequireDefault(_LanguagesMenu);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var shouldDisplayItemsLeft = function shouldDisplayItemsLeft(logoPosition) {
  return ['right'].indexOf(logoPosition) > -1;
};
var shouldSplitItems = function shouldSplitItems(logoPosition) {
  return ['middle'].indexOf(logoPosition) > -1;
};
var shouldCenterItems = function shouldCenterItems(logoPosition, responsiveMode) {
  return ['middle', 'top'].indexOf(logoPosition) > -1 && responsiveMode === _ResponsiveModes.DESKTOP;
};
var styles = {
  Navbar: {
    position: function position(_ref) {
      var navPosition = _ref.otherProperties.navPosition,
        editable = _ref.editable;
      return editable ? 'static' : navPosition || 'static';
    },
    zIndex: function zIndex(_ref2) {
      var navPosition = _ref2.otherProperties.navPosition;
      return navPosition === 'fixed' ? '100' : '0';
    },
    width: function width(_ref3) {
      var responsiveMode = _ref3.responsiveMode,
        preview = _ref3.preview;
      return !preview || responsiveMode === _ResponsiveModes.DESKTOP ? '100%' : responsiveMode === _ResponsiveModes.MOBILE ? '400px' : '800px';
    },
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: function flexDirection(_ref4) {
      var logoPosition = _ref4.otherProperties.logoPosition;
      return logoPosition === 'top-left' && 'column';
    },
    justifyContent: function justifyContent(_ref5) {
      var responsiveMode = _ref5.responsiveMode,
        logoPosition = _ref5.otherProperties.logoPosition;
      return shouldCenterItems(logoPosition, responsiveMode) ? 'center' : 'space-between';
    },
    '& .nav-items': {
      display: 'flex',
      listStyle: 'none',
      alignSelf: function alignSelf(_ref6) {
        var navItemsAlignSelf = _ref6.otherProperties.navItemsAlignSelf;
        return navItemsAlignSelf || 'center';
      }
    },
    '& .nav-item': {
      boxSizing: 'border-box',
      color: 'inherit',
      textDecoration: 'none',
      display: 'flex',
      fontFamily: function fontFamily(_ref7) {
        var navItemFont = _ref7.otherProperties.navItemFont;
        return navItemFont;
      },
      fontWeight: function fontWeight(_ref8) {
        var navItemFontWeight = _ref8.otherProperties.navItemFontWeight;
        return navItemFontWeight;
      },
      alignItems: 'center',
      cursor: 'pointer',
      padding: function padding(_ref9) {
        var navItemPadding = _ref9.otherProperties.navItemPadding;
        return navItemPadding;
      },
      borderRadius: function borderRadius(_ref10) {
        var navItemBorderRadius = _ref10.otherProperties.navItemBorderRadius;
        return navItemBorderRadius;
      },
      borderWidth: function borderWidth(_ref11) {
        var navItemActiveBorderThickness = _ref11.otherProperties.navItemActiveBorderThickness;
        return navItemActiveBorderThickness || '2px';
      },
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderBottomColor: function borderBottomColor(_ref12) {
        var _ref12$otherPropertie = _ref12.otherProperties,
          navItemUnderline = _ref12$otherPropertie.navItemUnderline,
          navItemO = _ref12$otherPropertie.navItemO;
        return navItemUnderline;
      },
      borderRight: function borderRight(_ref13) {
        var _ref13$otherPropertie = _ref13.otherProperties,
          navItemUnderline = _ref13$otherPropertie.navItemUnderline,
          navItemHoverUnderline = _ref13$otherPropertie.navItemHoverUnderline,
          navItemActiveUnderline = _ref13$otherPropertie.navItemActiveUnderline,
          navItemActiveOverline = _ref13$otherPropertie.navItemActiveOverline;
        return (navItemUnderline || navItemHoverUnderline || navItemActiveUnderline || navItemActiveOverline) && 'none';
      },
      borderLeft: function borderLeft(_ref14) {
        var _ref14$otherPropertie = _ref14.otherProperties,
          navItemUnderline = _ref14$otherPropertie.navItemUnderline,
          navItemHoverUnderline = _ref14$otherPropertie.navItemHoverUnderline,
          navItemActiveUnderline = _ref14$otherPropertie.navItemActiveUnderline,
          navItemActiveOverline = _ref14$otherPropertie.navItemActiveOverline;
        return (navItemUnderline || navItemHoverUnderline || navItemActiveUnderline || navItemActiveOverline) && 'none';
      },
      margin: function margin(_ref15) {
        var navItemMargin = _ref15.otherProperties.navItemMargin;
        return navItemMargin;
      },
      '&:hover': {
        background: function background(_ref16) {
          var navItemHoverBackground = _ref16.otherProperties.navItemHoverBackground;
          return navItemHoverBackground;
        },
        borderColor: function borderColor(_ref17) {
          var navItemHoverBorder = _ref17.otherProperties.navItemHoverBorder;
          return navItemHoverBorder;
        },
        borderBottomColor: function borderBottomColor(_ref18) {
          var navItemHoverUnderline = _ref18.otherProperties.navItemHoverUnderline;
          return navItemHoverUnderline;
        },
        color: function color(_ref19) {
          var navItemHoverTextColor = _ref19.otherProperties.navItemHoverTextColor;
          return navItemHoverTextColor;
        }
      },
      '&.active': {
        background: function background(_ref20) {
          var navItemActiveBackground = _ref20.otherProperties.navItemActiveBackground;
          return navItemActiveBackground;
        },
        borderColor: function borderColor(_ref21) {
          var navItemActiveBorder = _ref21.otherProperties.navItemActiveBorder;
          return navItemActiveBorder;
        },
        borderBottomColor: function borderBottomColor(_ref22) {
          var navItemActiveUnderline = _ref22.otherProperties.navItemActiveUnderline;
          return navItemActiveUnderline;
        },
        borderTopColor: function borderTopColor(_ref23) {
          var navItemActiveOverline = _ref23.otherProperties.navItemActiveOverline;
          return navItemActiveOverline;
        },
        color: function color(_ref24) {
          var navItemActiveTextColor = _ref24.otherProperties.navItemActiveTextColor;
          return navItemActiveTextColor;
        }
      }
    }
  },
  LogoWrapper: {
    width: function width(_ref25) {
      var logoPosition = _ref25.otherProperties.logoPosition;
      return logoPosition === 'top' ? '100%' : logoPosition === 'left' ? 'unset' : '9rem';
    },
    height: function height(_ref26) {
      var logoHeight = _ref26.otherProperties.logoHeight;
      return logoHeight;
    },
    textAlign: 'center',
    marginBottom: function marginBottom(_ref27) {
      var logoPosition = _ref27.otherProperties.logoPosition;
      return logoPosition === 'top' && '1rem';
    },
    marginLeft: function marginLeft(_ref28) {
      var logoPosition = _ref28.otherProperties.logoPosition;
      return logoPosition === 'top-left' && '1rem';
    }
  },
  helper: {
    display: 'inline-block',
    height: '100%',
    verticalAlign: 'middle'
  },
  logo: {
    objectFit: 'contain',
    alignSelf: function alignSelf(_ref29) {
      var logoAlignSelf = _ref29.otherProperties.logoAlignSelf;
      return logoAlignSelf || 'center';
    },
    maxWidth: '100%',
    maxHeight: '100%',
    verticalAlign: 'middle'
  },
  sideLogo: {
    display: 'block',
    margin: '1rem auto',
    maxWidth: '80%',
    maxHeight: '100%',
    verticalAlign: 'middle'
  },
  sideNavContainer: {
    '& .nav-items': {
      listStyle: 'none',
      padding: 0,
      width: '15rem',
      marginTop: function marginTop(_ref30) {
        var responsiveMode = _ref30.responsiveMode;
        return responsiveMode === _ResponsiveModes.DESKTOP ? '0' : '6rem';
      }
    },
    '& .nav-item': {
      boxSizing: 'border-box',
      color: 'inherit',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      padding: function padding(_ref31) {
        var navItemPadding = _ref31.otherProperties.navItemPadding;
        return navItemPadding;
      },
      borderWidth: function borderWidth(_ref32) {
        var navItemActiveBorderThickness = _ref32.otherProperties.navItemActiveBorderThickness;
        return navItemActiveBorderThickness || '2px';
      },
      borderStyle: 'solid',
      borderColor: function borderColor(_ref33) {
        var navItemHoverBorder = _ref33.otherProperties.navItemHoverBorder;
        return navItemHoverBorder && 'transparent';
      },
      borderRightColor: function borderRightColor(_ref34) {
        var navItemUnderline = _ref34.otherProperties.navItemUnderline;
        return navItemUnderline;
      },
      '&:hover': {
        background: function background(_ref35) {
          var navItemHoverBackground = _ref35.otherProperties.navItemHoverBackground;
          return navItemHoverBackground;
        },
        borderColor: function borderColor(_ref36) {
          var navItemHoverBorder = _ref36.otherProperties.navItemHoverBorder;
          return navItemHoverBorder;
        },
        borderRightColor: function borderRightColor(_ref37) {
          var navItemHoverUnderline = _ref37.otherProperties.navItemHoverUnderline;
          return navItemHoverUnderline;
        }
      },
      '&.active': {
        background: function background(_ref38) {
          var navItemActiveBackground = _ref38.otherProperties.navItemActiveBackground;
          return navItemActiveBackground;
        },
        borderColor: function borderColor(_ref39) {
          var navItemActiveBorder = _ref39.otherProperties.navItemActiveBorder;
          return navItemActiveBorder;
        },
        borderRightColor: function borderRightColor(_ref40) {
          var navItemActiveUnderline = _ref40.otherProperties.navItemActiveUnderline;
          return navItemActiveUnderline;
        },
        color: function color(_ref41) {
          var navItemActiveTextColor = _ref41.otherProperties.navItemActiveTextColor;
          return navItemActiveTextColor;
        }
      }
    }
  },
  socialMedia: {
    display: 'flex',
    fontSize: '1.25rem',
    position: function position(_ref42) {
      var responsiveMode = _ref42.responsiveMode,
        logoPosition = _ref42.otherProperties.logoPosition;
      return shouldCenterItems(logoPosition, responsiveMode) && 'absolute';
    },
    right: function right(_ref43) {
      var responsiveMode = _ref43.responsiveMode,
        logoPosition = _ref43.otherProperties.logoPosition;
      return shouldCenterItems(logoPosition, responsiveMode) && '1rem';
    },
    alignSelf: function alignSelf(_ref44) {
      var responsiveMode = _ref44.responsiveMode,
        logoPosition = _ref44.otherProperties.logoPosition;
      return shouldCenterItems(logoPosition, responsiveMode) && 'center';
    },
    '& a': {
      color: function color(_ref45) {
        var socialMediaIconColor = _ref45.otherProperties.socialMediaIconColor;
        return socialMediaIconColor;
      },
      display: 'inline-flex',
      textDecoration: 'none',
      alignSelf: 'center',
      margin: '0 0 0 1rem',
      '&:first-of-type': {
        margin: 0
      }
    },
    '& svg': {
      fill: 'currentColor',
      width: '1.25rem',
      height: '1.25rem',
      display: 'block'
    }
  }
};
var Navbar = function (_Component) {
  _inherits(Navbar, _Component);
  function Navbar(props) {
    _classCallCheck(this, Navbar);
    var _this = _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call(this, props));
    _this.moveDownWebSite = function () {
      var _this$props = _this.props,
        otherProperties = _this$props.otherProperties,
        editable = _this$props.editable;
      var navPosition = otherProperties.navPosition;
      if (!editable && navPosition === 'fixed') {
        var navbar = _this.navbarRef.current;
        var verticalOffsetDiv = _this.offsetDivRef.current;
        if (!!verticalOffsetDiv) {
          verticalOffsetDiv.style.height = navbar.offsetHeight + 'px';
        }
      }
    };
    _this.toggleDrawer = function (drawerOpen) {
      return function () {
        return _this.setState({
          drawerOpen: drawerOpen
        });
      };
    };
    _this.renderNavItems = function (items, customItems) {
      return _react2.default.createElement('ul', {
        className: 'nav-items'
      }, !!items && items.filter(function (item) {
        return !item.hideFromNavbar;
      }).map(function (item) {
        return _react2.default.createElement('li', {
          key: item.id
        }, _react2.default.createElement(_reactRouterDom.Link, {
          to: _this.getUrl(item),
          className: 'nav-item ' + (item.id === _this.props.currentPageId ? 'active' : '')
        }, item.name));
      }), !!customItems && !!customItems.length && customItems.map(function (extra_item) {
        return _react2.default.createElement('li', {
          key: extra_item.text
        }, _react2.default.createElement('a', {
          href: extra_item.link,
          target: extra_item.newTab ? '_blank' : '_self',
          className: 'nav-item'
        }, extra_item.text));
      }));
    };
    _this.getUrl = function (page) {
      var _this$props2 = _this.props,
        match = _this$props2.match,
        location = _this$props2.location;
      var pathParts = match.path.split('/');
      var urlParts = match.url.split('/');
      var indexOfPage = pathParts.indexOf(':page?');
      if (indexOfPage === -1 || urlParts.length < pathParts.length) return (0, _misc.appendSlashIfNeeded)(match.url) + (0, _pages.getPageUrl)(page) + (location.search || '');
      urlParts.splice(indexOfPage, 1, (0, _pages.getPageUrl)(page));
      return (0, _misc.appendSlashIfNeeded)(urlParts.join('/')) + (location.search || '');
    };
    _this.renderSocialMedia = function (className, _ref46) {
      var facebookLink = _ref46.facebookLink,
        twitterLink = _ref46.twitterLink,
        linkedInLink = _ref46.linkedInLink,
        instagramLink = _ref46.instagramLink,
        youTubeLink = _ref46.youTubeLink;
      return _react2.default.createElement('div', {
        className: className
      }, facebookLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(facebookLink),
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-facebook-square'
      })), twitterLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(twitterLink),
        target: '_blank'
      }, _react2.default.createElement('svg', {
        fill: 'currentColor'
      }, _react2.default.createElement('use', {
        href: _xTwitter2.default + '#x-twitter-logo'
      }))), linkedInLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(linkedInLink),
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-linkedin-square'
      })), instagramLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(instagramLink),
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-instagram'
      })), youTubeLink && _react2.default.createElement('a', {
        href: (0, _misc.prependHttpIfNeeded)(youTubeLink),
        target: '_blank'
      }, _react2.default.createElement('i', {
        className: 'fa fa-youtube-play'
      })));
    };
    _this.getLogo = function (className) {
      var _this$props3 = _this.props,
        classes = _this$props3.classes,
        entities = _this$props3.entities,
        otherProperties = _this$props3.otherProperties;
      var logoSrc = otherProperties.logoSrc,
        homeUrl = otherProperties.homeUrl;
      var event = Object.keys(entities).map(function (k) {
        return entities[k];
      })[0];
      var logoTags = _react2.default.createElement('div', {
        className: classes.LogoWrapper
      }, _react2.default.createElement('span', {
        className: classes.helper
      }), logoSrc || event.logo.filename ? _react2.default.createElement('img', {
        className: className,
        src: logoSrc || event.logo.medium,
        alt: 'event logo'
      }) : _react2.default.createElement(_logoEventtia2.default, {
        className: className,
        style: {
          fill: 'currentColor'
        }
      }));
      if (!homeUrl) return logoTags;
      return _react2.default.createElement('a', {
        href: homeUrl
      }, logoTags);
    };
    _this.splitPages = function (pages, extraPages) {
      if (!extraPages || extraPages.length === 0) return [pages.slice(0, Math.floor(pages.length / 2)), null, pages.slice(Math.floor(pages.length / 2)), null];
      var avgLength = Math.floor((pages.length + extraPages.length) / 2);
      var pivot = avgLength - pages.length;
      if (pivot < 0) return [pages.slice(0, avgLength), null, pages.slice(avgLength), extraPages];else if (pivot === 0) return [pages, null, null, extraPages];else return [pages, extraPages.slice(0, pivot), null, extraPages.slice(pivot)];
    };
    _this.navbarRef = _react2.default.createRef();
    _this.offsetDivRef = _react2.default.createRef();
    _this.state = {
      drawerOpen: false
    };
    return _this;
  }
  _createClass(Navbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.moveDownWebSite();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.moveDownWebSite();
    }

    // Returns an array with four arrays, first are the pages in the left side,
    // second are the aditionalPages in the left side, third are the pages in the
    // right side and fourth are the aditionalPages in the right side
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        cssProperties = _props.cssProperties,
        otherProperties = _props.otherProperties,
        pages = _props.pages,
        responsiveMode = _props.responsiveMode,
        editable = _props.editable,
        preview = _props.preview,
        entities = _props.entities;
      var logoPosition = otherProperties.logoPosition,
        socialMedia = otherProperties.socialMedia,
        linkSelector = otherProperties.linkSelector,
        navPosition = otherProperties.navPosition,
        languageSelector = otherProperties.languageSelector;
      var websiteLanguages = Object.keys(entities).map(function (k) {
        return entities[k];
      })[0].websiteLanguages;
      var _splitPages = this.splitPages(pages, linkSelector),
        _splitPages2 = _slicedToArray(_splitPages, 4),
        firstHalf = _splitPages2[0],
        extraFirstHalf = _splitPages2[1],
        secondHalf = _splitPages2[2],
        extraSecondHalf = _splitPages2[3];
      return _react2.default.createElement(_react2.default.Fragment, null, responsiveMode === _ResponsiveModes.DESKTOP ? _react2.default.createElement('nav', {
        className: classes.Navbar,
        style: cssProperties,
        ref: this.navbarRef
      }, socialMedia && shouldDisplayItemsLeft(logoPosition) && this.renderSocialMedia(classes.socialMedia, otherProperties), shouldDisplayItemsLeft(logoPosition) && this.renderNavItems(pages, linkSelector), shouldSplitItems(logoPosition) && this.renderNavItems(firstHalf, extraFirstHalf), this.getLogo(classes.logo), shouldSplitItems(logoPosition) && this.renderNavItems(secondHalf, extraSecondHalf), !shouldDisplayItemsLeft(logoPosition) && !shouldSplitItems(logoPosition) && this.renderNavItems(pages, linkSelector), socialMedia && !shouldDisplayItemsLeft(logoPosition) && this.renderSocialMedia(classes.socialMedia, otherProperties), languageSelector && _react2.default.createElement(_LanguagesMenu2.default, {
        availableLanguages: websiteLanguages
      })) : _react2.default.createElement('nav', {
        className: classes.Navbar,
        style: cssProperties,
        ref: this.navbarRef
      }, _react2.default.createElement(_IconButton2.default, {
        color: 'inherit',
        onClick: this.toggleDrawer(true)
      }, _react2.default.createElement(_Menu2.default, null)), !editable && _react2.default.createElement(_Drawer2.default, {
        open: this.state.drawerOpen,
        onClose: this.toggleDrawer(false)
      }, _react2.default.createElement('div', {
        tabIndex: 0,
        role: 'button',
        onClick: this.toggleDrawer(false),
        onKeyDown: this.toggleDrawer(false),
        className: classes.sideNavContainer,
        style: _extends({}, cssProperties, {
          height: '100%',
          padding: 0,
          overflow: 'auto'
        })
      }, this.getLogo(classes.sideLogo), this.renderNavItems(pages, linkSelector), socialMedia && this.renderSocialMedia(classes.socialMedia, otherProperties))), languageSelector && _react2.default.createElement(_LanguagesMenu2.default, {
        availableLanguages: websiteLanguages
      })), navPosition === 'fixed' && _react2.default.createElement('div', {
        className: classes.offsetDivRef,
        ref: this.offsetDivRef
      }));
    }
  }]);
  return Navbar;
}(_react.Component);
exports.default = (0, _reactRouter.withRouter)((0, _reactJss2.default)(styles)(Navbar));